import { Card } from 'react-bootstrap';

const BaseCard = ({ title, imageSrc, imageVariant = 'top', className, children }) => {
  return (
    <Card className={className}>
      {imageSrc && <Card.Img variant={imageVariant} src={imageSrc} />}
      <Card.Body>
        {title && <Card.Title>{title}</Card.Title>}
        {children}
      </Card.Body>
    </Card>
  );
};

export default BaseCard;
